import { getConstructorName, isConstructor } from './../utils/utils';
// 该模块用于存储可复用的错误信息常量。
// 一方面利于代码复用、降低维护成本；另一方面利于代码压缩。
// @ts-nocheck

import { UserRole } from '../enums';
import { getValueType } from '../utils/utils';

export const ErrorName = {
  // avoidRepeatedCall
  AVOID_REPEATED_CALL: 'AVOID_REPEATED_CALL',
  INVALID_PARAMETER_REQUIRED: 'INVALID_PARAMETER_REQUIRED',
  INVALID_PARAMETER_TYPE: 'INVALID_PARAMETER_TYPE',
  INVALID_PARAMETER_EMPTY: 'INVALID_PARAMETER_EMPTY',
  INVALID_PARAMETER_INSTANCE: 'INVALID_PARAMETER_INSTANCE',
  INVALID_PARAMETER_RANGE: 'INVALID_PARAMETER_RANGE',
  INVALID_PARAMETER_MIN: 'INVALID_PARAMETER_MIN',
  INVALID_PARAMETER_MAX: 'INVALID_PARAMETER_MAX',
  INVALID_PARAMETER_STREAMTYPE: 'INVALID_PARAMETER_STREAMTYPE',
  // signal-channel
  API_CALL_TIMEOUT: 'API_CALL_TIMEOUT',
  SIGNAL_CHANNEL_RECONNECTION_FAILED: 'SIGNAL_CHANNEL_RECONNECTION_FAILED',
  SIGNAL_CHANNEL_SETUP_FAILED: 'SIGNAL_CHANNEL_SETUP_FAILED',
  // downlink
  ERROR_MESSAGE: 'ERROR_MESSAGE',
  EXCHANGE_SDP_TIMEOUT: 'EXCHANGE_SDP_TIMEOUT',
  DOWNLINK_RECONNECTION_FAILED: 'DOWNLINK_RECONNECTION_FAILED',
  EXCHANGE_SDP_FAILED: 'EXCHANGE_SDP_FAILED',
  // uplink
  UPDATE_OFFER_TIMEOUT: 'UPDATE_OFFER_TIMEOUT',
  UPLINK_RECONNECTION_FAILED: 'UPLINK_RECONNECTION_FAILED',
  // client
  INVALID_RECORDID: 'INVALID_RECORDID',
  INVALID_PURE_AUDIO: 'INVALID_PURE_AUDIO',
  INVALID_STREAMID: 'INVALID_STREAMID',
  INVALID_USER_DEFINE_RECORDID: 'INVALID_USER_DEFINE_RECORDID',
  INVALID_USER_DEFINE_PUSH_ARGS: 'INVALID_USER_DEFINE_PUSH_ARGS',
  INVALID_PROXY: 'INVALID_PROXY',
  INVALID_JOIN: 'INVALID_JOIN',
  INVALID_ROOMID_STRING: 'INVALID_ROOMID_STRING',
  INVALID_ROOMID_INTEGER: 'INVALID_ROOMID_INTEGER',
  INVALID_SIGNAL_CHANNEL: 'INVALID_SIGNAL_CHANNEL',
  JOIN_ROOM_TIMEOUT: 'JOIN_ROOM_TIMEOUT',
  JOIN_ROOM_FAILED: 'JOIN_ROOM_FAILED',
  REJOIN_ROOM_FAILED: 'REJOIN_ROOM_FAILED',
  INVALID_DESTROY: 'INVALID_DESTROY',
  INVALID_PUBLISH: 'INVALID_PUBLISH',
  INVALID_UNPUBLISH: 'INVALID_UNPUBLISH',
  INVALID_AUDIENCE: 'INVALID_AUDIENCE',
  INVALID_INITIALIZE: 'INVALID_INITIALIZE',
  INVALID_DUPLICATE_PUBLISHING: 'INVALID_DUPLICATE_PUBLISHING',
  INVALID_SUBSCRIBE_UNDEFINED: 'INVALID_SUBSCRIBE_UNDEFINED',
  INVALID_SUBSCRIBE_LOCAL: 'INVALID_SUBSCRIBE_LOCAL',
  INVALID_REMOTE_STREAM: 'INVALID_REMOTE_STREAM',
  SUBSCRIBE_FAILED: 'SUBSCRIBE_FAILED',
  INVALID_ROLE: 'INVALID_ROLE',
  INVALID_PARAMETER_SWITCH_ROLE: 'INVALID_PARAMETER_SWITCH_ROLE',
  INVALID_OPERATION_SWITCH_ROLE: 'INVALID_OPERATION_SWITCH_ROLE',
  SWITCH_ROLE_TIMEOUT: 'SWITCH_ROLE_TIMEOUT',
  SWITCH_ROLE_FAILED: 'SWITCH_ROLE_FAILED',
  CLIENT_BANNED: 'CLIENT_BANNED',
  INVALID_OPERATION_START_PUBLISH_CDN: 'INVALID_OPERATION_START_PUBLISH_CDN',
  INVALID_OPERATION_STOP_PUBLISH_CDN: 'INVALID_OPERATION_STOP_PUBLISH_CDN',
  INVALID_STREAM_ID: 'INVALID_STREAM_ID',
  START_PUBLISH_CDN_FAILED: 'START_PUBLISH_CDN_FAILED',
  STOP_PUBLISH_CDN_FAILED: 'STOP_PUBLISH_CDN_FAILED',
  START_MIX_TRANSCODE: 'START_MIX_TRANSCODE',
  STOP_MIX_TRANSCODE: 'STOP_MIX_TRANSCODE',
  INVALID_AUDIO_VOLUME: 'INVALID_AUDIO_VOLUME',
  ENABLE_SMALL_STREAM_PUBLISHED: 'ENABLE_SMALL_STREAM_PUBLISHED',
  DISABLE_SMALL_STREAM_PUBLISHED: 'DISABLE_SMALL_STREAM_PUBLISHED',
  NOT_SUPPORTED_SMALL_STREAM: 'NOT_SUPPORTED_SMALL_STREAM',
  INVALID_SMALL_STREAM_PROFILE: 'INVALID_SMALL_STREAM_PROFILE',
  INVALID_PARAMETER_REMOTE_STREAM: 'INVALID_PARAMETER_REMOTE_STREAM',
  INVALID_OPERATION_CHANGE_SMALL: 'INVALID_OPERATION_CHANGE_SMALL',
  REMOTE_NOT_PUBLISH_SMALL_STREAM: 'REMOTE_NOT_PUBLISH_SMALL_STREAM',
  INVALID_SWITCH_DEVICE: 'INVALID_SWITCH_DEVICE',
  INVALID_SWITCH_DEVICE_PUBLISHING: 'INVALID_SWITCH_DEVICE_PUBLISHING',
  INVALID_REPLACE_TRACK: 'INVALID_REPLACE_TRACK',
  INVALID_INITIALIZE_LOCAL_STREAM: 'INVALID_INITIALIZE_LOCAL_STREAM',
  INVALID_ADD_TRACK_REPETITIVE: 'INVALID_ADD_TRACK_REPETITIVE',
  INVALID_ADD_TRACK_REMOVING: 'INVALID_ADD_TRACK_REMOVING',
  INVALID_ADD_TRACK_PUBLISHING: 'INVALID_ADD_TRACK_PUBLISHING',
  INVALID_STREAM_INITIALIZED: 'INVALID_STREAM_INITIALIZED',
  INVALID_ADD_TRACK_NUMBER: 'INVALID_ADD_TRACK_NUMBER',
  INVALID_REMOVE_AUDIO_TRACK: 'INVALID_REMOVE_AUDIO_TRACK',
  INVALID_REMOVE_AUDIO_ADDING: 'INVALID_REMOVE_AUDIO_ADDING',
  INVALID_REMOVE_AUDIO_ON: 'INVALID_REMOVE_AUDIO_ON',
  INVALID_REMOVE_TRACK_PUBLISHING: 'INVALID_REMOVE_TRACK_PUBLISHING',
  INVALID_REMOVE_TRACK_NOT_TRACK: 'INVALID_REMOVE_TRACK_NOT_TRACK',
  INVALID_REMOVE_TRACK_NUMBER: 'INVALID_REMOVE_TRACK_NUMBER',
  INVALID_REPLACE_TRACK_NO_TRACK: 'INVALID_REPLACE_TRACK_NO_TRACK',
  REPEAT_JOIN: 'REPEAT_JOIN',
  CLIENT_DESTROYED: 'CLIENT_DESTROYED',
  NOT_BUG_PACKAGE: 'NOT_BUG_PACKAGE',

  // mixTranscode
  START_MIX_TRANSCODE_FAILED: 'START_MIX_TRANSCODE_FAILED',
  STOP_MIX_TRANSCODE_FAILED: 'STOP_MIX_TRANSCODE_FAILED',
  MIX_TRANSCODE_NOT_STARTED: 'MIX_TRANSCODE_NOT_STARTED',

  CANNOT_LESS_THAN_ZERO: 'CANNOT_LESS_THAN_ZERO',
  MIX_PARAMS_VIDEO_FRAMERATE: 'MIX_PARAMS_VIDEO_FRAMERATE',
  MIX_PARAMS_VIDEO_GOP: 'MIX_PARAMS_VIDEO_GOP',
  MIX_PARAMS_AUDIO_BITRATE: 'MIX_PARAMS_AUDIO_BITRATE',

  MIX_PARAMS_USER_Z_ORDER: 'MIX_PARAMS_USER_Z_ORDER',
  MIX_PARAMS_NOT_SELF: 'MIX_PARAMS_NOT_SELF',
  MIX_PARAMS_USER_STREAM: 'MIX_PARAMS_USER_STREAM',

  // stream
  INVALID_PLAY: 'INVALID_PLAY',
  INVALID_ELEMENT_ID: 'INVALID_ELEMENT_ID',
  INVALID_ELEMENT_ID_TYPE: 'INVALID_ELEMENT_ID_TYPE',
  PLAY_FAILED: 'PLAY_FAILED',
  // main
  INVALID_USERID: 'INVALID_USERID',
  INVALID_CREATE_STREAM_SOURCE: 'INVALID_CREATE_STREAM_SOURCE',
  INVALID_CREATE_STREAM_SCREEN: 'INVALID_CREATE_STREAM_SCREEN',
  INVALID_CREATE_STREAM_AUDIO: 'INVALID_CREATE_STREAM_AUDIO',
  INVALID_CREATE_STREAM_SCREEN_AUDIO: 'INVALID_CREATE_STREAM_SCREEN_AUDIO',
  // not supported
  NOT_SUPPORTED_HTTP: 'NOT_SUPPORTED_HTTP',
  NOT_SUPPORTED_WEBRTC: 'NOT_SUPPORTED_WEBRTC',
  NOT_SUPPORTED_PROFILE: 'NOT_SUPPORTED_PROFILE',
  NOT_SUPPORTED_MEDIA: 'NOT_SUPPORTED_MEDIA',
  NOT_SUPPORTED_H264ENCODE: 'NOT_SUPPORTED_H264ENCODE',
  NOT_SUPPORTED_H264DECODE: 'NOT_SUPPORTED_H264DECODE',
  NOT_SUPPORTED_TRACK: 'NOT_SUPPORTED_TRACK',
  NOT_SUPPORTED_SWITCH_DEVICE: 'NOT_SUPPORTED_SWITCH_DEVICE',
  NOT_SUPPORTED_CAPTURE: 'NOT_SUPPORTED_CAPTURE',
  NOT_SUPPORTED_AUX: 'NOT_SUPPORTED_AUX',
  // get user media
  MICROPHONE_NOT_FOUND: 'MICROPHONE_NOT_FOUND',
  CAMERA_NOT_FOUND: 'CAMERA_NOT_FOUND',
  // signal response Failed
  SIGNAL_RESPONSE_FAILED: 'SIGNAL_RESPONSE_FAILED',
  CATCH_HANDLER_ERROR: 'CATCH_HANDLER_ERROR',
  API_NOT_EXIST: 'API_NOT_EXIST',

  CONNECTION_CLOSED: 'CONNECTION_CLOSED',
  SUBSCRIBE_ALL_FALSE: 'SUBSCRIBE_ALL_FALSE',

  // sei
  SEI_NOT_SUPPORT: 'SEI_NOT_SUPPORT',
  SEI_DISABLED: 'SEI_DISABLED',
  SEI_BEFORE_PUBLISH: 'SEI_BEFORE_PUBLISH',
  SEI_NOT_VIDEO: 'SEI_NOT_VIDEO',

  CALL_FREQUENCY_LIMIT: 'CALL_FREQUENCY_LIMIT',
  CONNECTION_ABORTED: 'CONNECTION_ABORTED',
  API_CALL_ABORTED: 'API_CALL_ABORTED',
  DUPLICATE_AUX: 'DUPLICATE_AUX',
  SWITCH_PLAYBACK_QUALITY_TIMEOUT: 'SWITCH_PLAYBACK_QUALITY_TIMEOUT'
};

export const ErrorInfo = {
  AVOID_REPEATED_CALL(data) {
    return `previous ${data.name}() is ongoing, please avoid repeated calls.`;
  },
  INVALID_PARAMETER_REQUIRED({ key, rule, fnName, value }) {
    return `'${key ||
    rule.name}' is a required param when calling ${fnName}(), received: ${value}.`;
  },
  INVALID_PARAMETER_TYPE({ key, rule, fnName, value }) {
    const keyName = `${key || rule.name}`;
    let type = '';
    if (Array.isArray(rule.type)) {
      type = rule.type.join('|');
    } else {
      type = rule.type;
    }
    return `'${keyName}' must be type of ${type} when calling ${fnName}(), received type: ${getValueType(value)}.`;
  },
  INVALID_PARAMETER_EMPTY({ key, rule, fnName, value }) {
    return `'${key || rule.name}' cannot be '${value}' when calling ${fnName}().`;
  },
  INVALID_PARAMETER_INSTANCE({ key, rule, fnName, value }) {
    const keyName = `${key || rule.name}`;
    const name = `${rule.instanceOf.name || rule.instanceOf}`;
    return `'${keyName}' must be instanceof ${name} when calling ${fnName}(), received type: ${getValueType(value)}.`;
  },
  INVALID_PARAMETER_RANGE({ key, rule, fnName, value }) {
    return `'${key || rule.name}' must be one of ${rule.values.join('|')} when calling ${fnName}(), received: ${value}.`;
  },
  INVALID_PARAMETER_MIN({ key, rule, fnName, value }) {
    return `the min value of ${key || rule.name} is ${rule.min}, received: ${value}.`;
  },
  INVALID_PARAMETER_MAX({ key, rule, fnName, value }) {
    return `the max value of ${key || rule.name} is ${rule.max}, received: ${value}.`;
  },
  API_CALL_TIMEOUT(data) {
    return `${data.commandDesc || data.command} timeout observed.`;
  },
  SIGNAL_CHANNEL_RECONNECTION_FAILED:
    'signal channel reconnection failed, please check your network.',
  SIGNAL_CHANNEL_SETUP_FAILED(data) {
    return `SignalChannel setup failure: (errorCode: ${data.errorCode}, errorMsg: ${data.errorMsg} }).`;
  },
  // downlink
  ERROR_MESSAGE(data) {
    let errorMessage = `${data.type} failed`;
    if (data.message) {
      errorMessage = `${errorMessage}: ${data.message}.`;
    }
    return errorMessage;
  },
  EXCHANGE_SDP_TIMEOUT: 'exchange sdp timeout.',
  DOWNLINK_RECONNECTION_FAILED:
    'downlink reconnection failed, please check your network and re-join room.',
  EXCHANGE_SDP_FAILED(data) {
    return `exchange sdp failed ${data.errMsg}.`;
  },
  // uplink
  UPDATE_OFFER_TIMEOUT: 'update offer timeout observed.',
  UPLINK_RECONNECTION_FAILED:
    'uplink reconnection failed, please check your network and publish again.',
  // client
  INVALID_RECORDID: 'recordId must be an integer number.',
  INVALID_PURE_AUDIO: 'pureAudioPushMode must be 1 or 2.',
  INVALID_STREAMID: 'streamId must be a sting literal within 64 bytes, and not be empty.',
  INVALID_USER_DEFINE_RECORDID:
    'userDefineRecordId must be a sting literal contains (a-zA-Z),(0-9), underline and hyphen, within 64 bytes, and not be empty.',
  INVALID_USER_DEFINE_PUSH_ARGS:
    'userDefinePushArgs must be a sting literal within 256 bytes, and not be empty.',
  INVALID_PROXY: 'proxy server url must start with "wss://".',
  INVALID_JOIN: 'duplicate join() called.',
  INVALID_ROOMID_STRING(roomId) {
    return `'${roomId}' must be validate string when useStringRoomId is true.`;
  },
  INVALID_ROOMID_INTEGER(roomId) {
    return `'${roomId}' must be an integer between [1, 4294967294] when useStringRoomId is false.`;
  },
  INVALID_SIGNAL_CHANNEL: 'SignalChannel is not ready yet.',
  JOIN_ROOM_TIMEOUT: 'join room timeout.',
  JOIN_ROOM_FAILED({ error, code }) {
    return `Failed to join room - ${error} code: ${code}`;
  },
  REJOIN_ROOM_FAILED(data) {
    return `reJoin room: ${data.roomId} failed, please check your network.`;
  },
  INVALID_DESTROY: 'please call leave() before destroy().',
  INVALID_PUBLISH: 'please call join() before publish().',
  INVALID_UNPUBLISH: 'stream has not been published yet.',
  INVALID_AUDIENCE: `no permission to publish() under live/${UserRole.AUDIENCE}, please call switchRole("${UserRole.ANCHOR}") firstly before publish().`,
  INVALID_INITIALIZE:
    'cannot publish stream because stream is not initialized, is switching device, or has been closed.',
  INVALID_DUPLICATE_PUBLISHING(streamType) {
    return `duplicate ${streamType} stream publishing, please unpublish your prev ${streamType} stream and then re-publish.`;
  },
  INVALID_SUBSCRIBE_UNDEFINED: 'stream is undefined or null.',
  INVALID_SUBSCRIBE_LOCAL: 'stream cannot be LocalStream.',
  INVALID_REMOTE_STREAM:
    'remoteStream does not exist because it has been unpublished by remote peer.',
  SUBSCRIBE_FAILED({ message, userId, streamType }) {
    return `failed to subscribe ${userId} ${streamType} stream, reason: ${message}.`;
  },
  INVALID_ROLE: 'switchRole can only be called in live mode.',
  INVALID_PARAMETER_SWITCH_ROLE: `role could only be set to a value as ${UserRole.ANCHOR} or ${UserRole.AUDIENCE}.`,
  INVALID_OPERATION_SWITCH_ROLE: 'please call join() before switchRole().',
  SWITCH_ROLE_TIMEOUT: 'switchRole timeout.',
  SWITCH_ROLE_FAILED(data) {
    return `switchRole failed, errCode: ${data.code} errMsg: ${data.message}.`;
  },
  CLIENT_BANNED(data) {
    return `client was banned because of ${data.message}.`;
  },
  INVALID_OPERATION_START_PUBLISH_CDN: 'please call startPublishCDNStream() after join room and publish the local stream.',
  INVALID_OPERATION_STOP_PUBLISH_CDN: 'please call startPublishCDNStream() before stopPublishCDNStream().',
  START_PUBLISH_CDN_FAILED(data) {
    return `startPublishCDNStream failed, errMsg: ${data.message}.`;
  },
  STOP_PUBLISH_CDN_FAILED(data) {
    return `stopPublishCDNStream failed, errMsg: ${data.message}.`;
  },
  INVALID_STREAM_ID(streamId) {
    return `'${streamId}' can only consist of uppercase and lowercase english letters (a-zA-Z), numbers (0-9), hyphens and underscores.`;
  },
  START_MIX_TRANSCODE: 'please call startMixTranscode() after join().',
  STOP_MIX_TRANSCODE: 'please call stopMixTranscode() after startMixTranscode().',
  INVALID_AUDIO_VOLUME: 'interval must be a number.',
  ENABLE_SMALL_STREAM_PUBLISHED: 'Cannot enable small stream after localStream published.',
  DISABLE_SMALL_STREAM_PUBLISHED: 'Cannot disable small stream after localStream published.',
  NOT_SUPPORTED_SMALL_STREAM: 'your browser does not support opening small stream.',
  INVALID_SMALL_STREAM_PROFILE: 'small stream profile is invalid.',
  INVALID_PARAMETER_REMOTE_STREAM: 'remoteStream is invalid.',
  INVALID_OPERATION_CHANGE_SMALL:
    'cannot switch to the small stream without subscribing to the video of remoteStream.',
  REMOTE_NOT_PUBLISH_SMALL_STREAM: 'remote peer does not publish small stream.',
  // local stream
  INVALID_SWITCH_DEVICE: 'cannot switch device on current stream.',
  INVALID_SWITCH_DEVICE_PUBLISHING: 'cannot switch device when publishing localStream.',
  INVALID_REPLACE_TRACK: 'cannot replace track when publishing localStream.',
  INVALID_INITIALIZE_LOCAL_STREAM: 'local stream has not initialized yet.',
  INVALID_ADD_TRACK_REPETITIVE: 'previous addTrack is ongoing, please avoid repetitive execution.',
  INVALID_ADD_TRACK_REMOVING: 'cannot add track when a track is removing.',
  INVALID_ADD_TRACK_PUBLISHING: 'cannot add track when publishing localStream.',
  INVALID_STREAM_INITIALIZED: 'your local stream haven\'t been initialized yet.',
  INVALID_ADD_TRACK_NUMBER: 'a Stream has at most one audio track and one video track.',
  INVALID_REMOVE_AUDIO_TRACK: 'remove audio track is not supported on your browser.',
  INVALID_REMOVE_AUDIO_ADDING: 'cannot remove track when a track is adding.',
  INVALID_REMOVE_AUDIO_ON: 'previous removeTrack is ongoing, please avoid repetitive execution.',
  INVALID_REMOVE_TRACK_PUBLISHING: 'cannot remove track when publishing localStream.',
  INVALID_REMOVE_TRACK_NOT_TRACK: 'localStream has not this track.',
  INVALID_REMOVE_TRACK_NUMBER:
    'remove the only video track is not supported, please use replaceTrack or muteVideo.',
  INVALID_REPLACE_TRACK_NO_TRACK(track) {
    return `cannot replace ${track.kind} track because stream has not ${track.kind} track`;
  },
  NOT_BUG_PACKAGE: 'You need to buy packages, refer to tencent console.',
  // mixTranscode
  START_MIX_TRANSCODE_FAILED(data) {
    return `startMixTranscode failed, errMsg: ${data.message}.`;
  },
  STOP_MIX_TRANSCODE_FAILED(data) {
    return `stopMixTranscode failed, errMsg: ${data.message}.`;
  },
  MIX_TRANSCODE_NOT_STARTED: 'mixTranscode has not been started.',
  CANNOT_LESS_THAN_ZERO({ key, rule, fnName, value }) {
    return `'${key || rule.name}' cannot be less than 0 when calling ${fnName}().`;
  },
  MIX_PARAMS_VIDEO_FRAMERATE:
    '\'config.videoFramerate\' should be an integer between 0 and 30, excluding 0.',
  MIX_PARAMS_VIDEO_GOP: '\'config.videoGOP\' should be an integer between 1 and 8.',
  MIX_PARAMS_AUDIO_BITRATE: '\'config.audioBitrate\' should be an integer between 32 and 192.',
  MIX_PARAMS_USER_Z_ORDER(data) {
    return `'${data}' is required and must be between 1 and 15.`;
  },
  MIX_PARAMS_NOT_SELF: '\'config.mixUsers\' must contain self.',
  MIX_PARAMS_USER_STREAM:
    '\'config.videoWidth\' and \'config.videoHeight\' of output stream should be contain all mix stream.',
  // stream
  INVALID_PLAY: 'duplicate play() call observed, please stop() firstly.',
  INVALID_ELEMENT_ID: ({ key, fnName }) => `'${key}' is not found in the document object when calling ${fnName}().`,
  INVALID_ELEMENT_ID_TYPE: ({ key, fnName, type }) => `the element corresponding to '${key}' must be instanceof HTMLElement when calling ${fnName}(), received: ${type}.`,
  // stream player
  PLAY_FAILED: data => `${data.media} play failed, browser exception: ${data.error.toString()}`,
  // main
  INVALID_USERID: 'userId cannot be all spaces.',
  INVALID_CREATE_STREAM_SOURCE:
    'LocalStream must be created by createStream() with either audio/video or audioSource/videoSource, but can not be mixed with audio/video and audioSource/videoSource.',
  INVALID_CREATE_STREAM_SCREEN: 'screen/video cannot be both true.',
  INVALID_CREATE_STREAM_AUDIO: 'audio/screenAudio cannot be both true.',
  INVALID_CREATE_STREAM_SCREEN_AUDIO: 'when screen is true, screenAudio can be configured.',
  // not supported
  NOT_SUPPORTED_HTTP:
    'http protocol does not support the ability to capture microphone, camera and screen. please use https to deploy your page.',
  NOT_SUPPORTED_WEBRTC: 'your browser or environment does not support full WebRTC capabilities.',
  NOT_SUPPORTED_PROFILE: 'your browser does not support setVideoProfile.',
  NOT_SUPPORTED_MEDIA: 'your browser or environment does not support navigator.mediaDevices.',
  NOT_SUPPORTED_H264ENCODE: 'your device does not support H.264 encoding.',
  NOT_SUPPORTED_H264DECODE: 'your device does not support H.264 decoding.',
  NOT_SUPPORTED_TRACK(action) {
    return `${action}Track is not supported on your browser.`;
  },
  NOT_SUPPORTED_SWITCH_DEVICE: 'switchDevice is not supported on your browser.',
  NOT_SUPPORTED_CAPTURE:
    'Your browser or environment does not support screen sharing, please check whether the browser version.',
  // get user media
  MICROPHONE_NOT_FOUND:
    'no microphone detected, please check your microphone.',
  CAMERA_NOT_FOUND:
    'no camera detected, please check your camera.',
  SIGNAL_RESPONSE_FAILED(data) {
    return `${data.signalResponse} failed, response code is ${data.code} , errMsg: ${data.message}.`;
  },
  CATCH_HANDLER_ERROR({ name, event }) {
    return `an error was caught in ${name}.on('${event}', handler), please check your code in 'handler'.`;
  },
  API_NOT_EXIST({ name }) {
    return `experimental api ${name} does not exist.`;
  },
  REPEAT_JOIN: userId => 'please avoid repeated join.',
  CONNECTION_CLOSED:
    'remoteStream has been unsubscribed or unpublished by remote user.',
  SUBSCRIBE_ALL_FALSE:
    'cannot subscribe when both audio & video are false, use client.unsubscribe() instead',
  CLIENT_DESTROYED({ funName }) {
    return `failed to call ${funName}() because client was destroyed.`;
  },
  // sei
  SEI_NOT_SUPPORT: isH264 => `not support to sendSEIMessage${isH264 === false ? ' without using h264 codec' : ''}`,
  SEI_DISABLED: 'SEI is disabled',
  SEI_BEFORE_PUBLISH: 'please call sendSEIMessage() after publish() success',
  SEI_NOT_VIDEO: 'cannot send sei when localStream has not video.',
  CALL_FREQUENCY_LIMIT: ({ isSize, name, timesInSecond, maxSizeInSecond }) => `api ${name} call ${isSize ? 'size' : 'times'} is over ${
    isSize ? `${maxSizeInSecond} bytes` : timesInSecond
  } in a second.`,
  CONNECTION_ABORTED(reason) {
    return `connection aborted due to: ${reason}`;
  },
  API_CALL_ABORTED(data) {
    let message;
    if (data.message.includes('REMOTE_STREAM_NOT_EXIST')) {
      // 远端取消推流导致订阅中断
      message = `Subscribe ${data.userId} ${data.streamType} stream aborted, reason: remote user ${data.userId} unpublished stream.`;
    } else {
      message = `API aborted, reason: ${data.message}`;
    }
    return message;
  },
  DUPLICATE_AUX: 'only one auxiliary stream can be published in a room.',
  NOT_SUPPORTED_AUX: 'publish auxiliary stream is not supported on your browser.',
  INVALID_PARAMETER_STREAMTYPE: (fnName: string) => `'streamType' is required when 'userId' is not '*', calling ${fnName}()`,
  SWITCH_PLAYBACK_QUALITY_TIMEOUT: (data: { userId: string }) => `switchPlaybackQuality timeout: waiting for first frame of user ${data.userId}.`
};
